export enum Role {
  OWNER = "OWNER",
  COLLABORATOR = "COLLABORATOR",
}
